/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Editor_HintInputs */



/**
* | output |
* | --- |
* | "Pick a starting design, then tune the colors, fonts, and text size. The preview updates live." |
*
* @param {Presentation_Template_Editor_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_editor_hint = /** @type {((inputs?: Presentation_Template_Editor_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Editor_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie ein Ausgangsdesign und passen Sie dann Farben, Schriften und Textgröße an. Die Vorschau aktualisiert sich live.")
	return /** @type {LocalizedString} */ ("Pick a starting design, then tune the colors, fonts, and text size. The preview updates live.")
});